var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_168_1592",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83325 1.83334H14.8178V14.818H1.83325V1.83334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_168_1592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32568 2.83334C5.29701 2.83334 2.83301 5.29668 2.83301 8.32534C2.83301 11.354 5.29701 13.818 8.32568 13.818C11.3537 13.818 13.8177 11.354 13.8177 8.32534C13.8177 5.29668 11.3537 2.83334 8.32568 2.83334ZM8.32568 14.818C4.74567 14.818 1.83301 11.9053 1.83301 8.32534C1.83301 4.74534 4.74567 1.83334 8.32568 1.83334C11.9057 1.83334 14.8177 4.74534 14.8177 8.32534C14.8177 11.9053 11.9057 14.818 8.32568 14.818Z",
    fill: "#DC1E79"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_168_1592",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 5,
    height: 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9932 12.3046H15.3425V15.6478H11.9932V12.3046Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_168_1592)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8427 15.6478C14.7153 15.6478 14.5873 15.5991 14.4893 15.5018L12.14 13.1591C11.9447 12.9638 11.944 12.6471 12.1393 12.4518C12.334 12.2551 12.6507 12.2565 12.8467 12.4505L15.196 14.7938C15.3913 14.9891 15.392 15.3051 15.1967 15.5005C15.0993 15.5991 14.9707 15.6478 14.8427 15.6478Z",
    fill: "#DC1E79"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.7f8ec290b7fc87407e8d513710f941ee.svg";
export { ForwardRef as ReactComponent };